module.exports = __webpack_public_path__ + "img/new_11.83db8e7a.jpg";